import "./ImageSlider.scss";


// Components
import React, { useCallback, useEffect, useRef, useState } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import {
    NextButton,
    PrevButton,
    usePrevNextButtons
} from './EmblaCarouselArrowButtons'
import { DotButton, useDotButton } from './EmblaCarouselDotButton'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare, faCircle, faCircleDot } from "@fortawesome/free-solid-svg-icons";

const TWEEN_FACTOR_BASE = 0.2

const ImageSlider = (props) => {
    const { slides, options } = props
    const [emblaRef, emblaApi] = useEmblaCarousel(options)
    const tweenFactor = useRef(0)
    const tweenNodes = useRef([])

    // Hover Variables
    const [project__slide__hover, set_project__slide__hover] = useState(null);

    const { selectedIndex, scrollSnaps, onDotButtonClick } =
        useDotButton(emblaApi)

    const {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick
    } = usePrevNextButtons(emblaApi)

    const setTweenNodes = useCallback((emblaApi) => {
        tweenNodes.current = emblaApi.slideNodes().map((slideNode) => {
            return slideNode.querySelector('.embla__parallax__layer')
        })
    }, [])

    const setTweenFactor = useCallback((emblaApi) => {
        tweenFactor.current = TWEEN_FACTOR_BASE * emblaApi.scrollSnapList().length
    }, [])

    const tweenParallax = useCallback((emblaApi, eventName) => {
        const engine = emblaApi.internalEngine()
        const scrollProgress = emblaApi.scrollProgress()
        const slidesInView = emblaApi.slidesInView()
        const isScrollEvent = eventName === 'scroll'

        emblaApi.scrollSnapList().forEach((scrollSnap, snapIndex) => {
            let diffToTarget = scrollSnap - scrollProgress
            const slidesInSnap = engine.slideRegistry[snapIndex]

            slidesInSnap.forEach((slideIndex) => {
                if (isScrollEvent && !slidesInView.includes(slideIndex)) return

                if (engine.options.loop) {
                    engine.slideLooper.loopPoints.forEach((loopItem) => {
                        const target = loopItem.target()

                        if (slideIndex === loopItem.index && target !== 0) {
                            const sign = Math.sign(target)

                            if (sign === -1) {
                                diffToTarget = scrollSnap - (1 + scrollProgress)
                            }
                            if (sign === 1) {
                                diffToTarget = scrollSnap + (1 - scrollProgress)
                            }
                        }
                    })
                }

                const translate = diffToTarget * (-1 * tweenFactor.current) * 100
                const tweenNode = tweenNodes.current[slideIndex]
                tweenNode.style.transform = `translateX(${translate}%)`
            })
        })
    }, [])

    useEffect(() => {
        if (!emblaApi) return

        setTweenNodes(emblaApi)
        setTweenFactor(emblaApi)
        tweenParallax(emblaApi)

        set_project__slide__hover()

        const projectSlideHoverElement = document.querySelector('.project__slide__hover');
        set_project__slide__hover(projectSlideHoverElement);

        if (project__slide__hover) {
            project__slide__hover.onClick = (e) => {
                console.log(e);
            };
        }

        emblaApi
            .on('reInit', setTweenNodes)
            .on('reInit', setTweenFactor)
            .on('reInit', tweenParallax)
            .on('scroll', tweenParallax)
            .on('slideFocus', tweenParallax)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [emblaApi, tweenParallax])

    return (
        <div className="embla">
            <div className="embla__viewport" ref={emblaRef}>
                <div className="embla__container">
                    {slides.map((project) => (
                        <div className="embla__slide" key={project.index}>
                            <div className="embla__parallax">
                                <div className="embla__parallax__layer">
                                    <div className="project__slide__overlay">
                                        <div className="project__slide__hover">
                                            <h1>{project.projectName}</h1>
                                            <div className="project__slide__row">
                                                <p className="project__slide__domain">{project.projectDomain}</p>
                                                <p className="project__slide__completion">{project.dataOfCompletion}</p>
                                            </div>
                                            <p className="project__description">{project.projectShortDescription}</p>
                                            <a className="project__view__more" href={`/project/${project.projectName}`}>View Project <FontAwesomeIcon icon={faArrowUpRightFromSquare} /></a>
                                        </div>
                                    </div>
                                    <img
                                        className="embla__slide__img embla__parallax__img"
                                        src={project.imgUrl}
                                        alt={project.projectName}
                                    />

                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="embla__controls">
                <div className="embla__buttons">
                    <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} style={{ color: "#FFF" }} />
                    <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} style={{ color: "#FFF" }} />
                </div>

                <div className="embla__dots">
                    {scrollSnaps.map((_, index) => (
                        <DotButton
                            key={index}
                            onClick={() => onDotButtonClick(index)}
                            className={'embla__dot'.concat(
                                index === selectedIndex ? ' embla__dot--selected' : ''
                            )}
                        >
                            {index === selectedIndex ? <FontAwesomeIcon style={{ color: "#FFF" }} icon={faCircleDot} /> : <FontAwesomeIcon style={{ color: "#FFF" }} icon={faCircle} />}
                        </DotButton>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ImageSlider;
